import PhotoUploaderAPI from './photo-uploader-api';

export default PhotoUploaderAPI;
